import React, { FC } from 'react';
import { Box, Modal, BoxProps, IconButton, Stack, Typography, Fade } from '@mui/material';
import { Close } from '@mui/icons-material';

interface Props extends BoxProps {
  title: string;
  open: boolean;
  width?: number | string;
  handleClose: () => void;
  children?: JSX.Element[] | JSX.Element;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export const CustomModal: FC<Props> = ({
  title,
  open,
  width = 400,
  handleClose,
  children,
  ...props
}) => {
  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <Box sx={{ ...style, width }} {...props}>
          <Stack
            flexGrow={1}
            direction="row"
            marginBottom={1}
            alignContent="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h5" marginTop="3px" color="black">
                {title}
              </Typography>
            </Box>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
          <Box></Box>
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};
